import axios from 'axios'

const request = axios.create({
    baseURL: 'https://kebeidianzi.com/',  //这里是全局统一加上了 后端接口前缀 前缀，后端必须进行跨域配置！
    // baseURL: "http://192.168.1.27:666/",//本地测试地址（方便交叉测试）
    // baseURL: "http://localhost:666/",//本地测试地址


    timeout: 1000000,
})
//http://119.91.196.193:999/
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    if (config.headers['Content-Type'] !== 'multipart/form-data') {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    // 统一附加 JWT（登录时已存入 localStorage.access_token），供后端 jwt_required 鉴权
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

request.defaults.withCredentials = true

export default request
